import { Typography, Dialog, DialogTitle, DialogActions, DialogContent, Button, Divider, Alert, Box, Link } from "@mui/material";
import { closelightbox } from "../../../util/Functions";
import { ModalStyle } from "../../../util/Styles";
import { useInsertBQHandle } from "./hooks/useInsertBQHandle";
import alert from '../../../images/alert.png'
import SnackbarContent from '@mui/material/SnackbarContent';
import DropZone from '../../elements/DropZone/DropZone';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';


const InsertBQChargeback = ({ open, changeAlert, changeLoader }) => {
    const { form, error, isValidForm, zPos, onConfirm, onFormReset, parseJson, onDownloadFile } = useInsertBQHandle(open, changeAlert, changeLoader);
    
    const action = (
        <Button size="small" variant="text" id='buttonText' onClick={onFormReset}>Cambiar</Button>
    );

    return (
        <Dialog open={true} fullWidth sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }}>
            <ModalStyle property={String(isValidForm)}>
                <DialogTitle>
                    <span>Carga Manual BL - BigQuery</span>
                </DialogTitle>

                <DialogContent>
                    { !form && 
                        <>
                        <Alert severity={"info"}>
                            Descarga el formato y llénalo con los datos indicados en el encabezado. No modifiques el formato del archivo.
                        </Alert>

                        <Box mt={2}>
                            <Link underline="none" color={null} display={"flex"} sx={{cursor: "pointer"}} width={"fit_content"} onClick={onDownloadFile.bind(this)}>
                                <ArrowCircleDownIcon sx={{verticalAlign: "middle", mr: 1}}/>
                                <Typography color={"inherit"}>Descargar formato.</Typography>
                            </Link>
                        </Box>
                        </>
                    }

					<Divider sx={{mt: 2}} />
                    {  (form && form["file_name"] ?
                        <Box sx={{mb: 1, textAlign: "center"}} display={"flex"}>
                            <Box component="img" alignSelf={"center"} alt="emptyList" src={alert} width={150}/>
                            <Box py={3} pl={2} alignContent={"center"}>
                                <SnackbarContent message={form["file_name"]} action={action} sx={{backgroundColor: "cadetblue", mb: 3, fontWeight: 800}} />
                                <Typography variant="body2">Realizarás la descarga de <b>{form["rows"].length} registros</b></Typography>
                                <Typography variant="body2">¿Deseas continuar?</Typography>
                            </Box>
                        </Box> 
                        :
                        <DropZone changeAlert={changeAlert} handleFile={parseJson} typeFile={["csv", "xls", "xlsx"]}/>
                    )}

                    {error && <Typography variant="body2" color="orangered">{error}</Typography>}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closelightbox} variant="outlined" id='buttonCancel'>
                        Cancelar
                    </Button>
                    <Button onClick={onConfirm.bind(this)} disabled={isValidForm} variant="contained">
                        Continuar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default InsertBQChargeback;
